import { INoShowProtection, PaymentUtils, Pill } from '@localina/core';
import { LockIcon } from '@localina/icons';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHaveAccountFeatures } from '../../api/queries/account';

/** Shift list: "🔒 CHF 30 p.P. ab 4" for shifts with No-Show Protection. */
export const NoShowProtectionPill: React.FC<{ protection?: INoShowProtection | null }> = ({ protection }) => {
    const { t, i18n } = useTranslation();
    // a guarantee stays on the shift when the add-on is switched off, but isn't asked for any more
    const [hasNoShowProtection] = useHaveAccountFeatures(['noShowProtection'], undefined, true);
    if (!protection || !hasNoShowProtection) {
        return null;
    }
    const amount = PaymentUtils.formatAmount(protection.amount, 'chf', i18n.language);
    const label = [
        t(
            protection.calculation === 'PER_PERSON'
                ? 'availability.noShowPill.perPerson'
                : 'availability.noShowPill.perReservation',
            { amount },
        ),
        protection.minPersons ? t('availability.noShowPill.from', { persons: protection.minPersons }) : null,
    ]
        .filter(Boolean)
        .join(' ');
    return (
        <Pill
            tone="teal"
            icon={<LockIcon />}
            label={label}
            title={t('availability.noShowPill.title')}
            extraClassName="no-show-pill"
        />
    );
};
